var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogogroup(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 892,
    height: 702.987,
    viewBox: "0 0 892 702.987",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "logogroup",
    transform: "translate(-1031.698 -171)"
  }, /*#__PURE__*/React.createElement("text", {
    id: "LUCKY_DUCK",
    "data-name": "LUCKY DUCK",
    transform: "translate(1033.698 720.986)",
    fill: "#1c6834",
    fontSize: 137,
    fontFamily: "CalifornianFB-Bold, Californian FB",
    fontWeight: 700
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "LUCKY DUCK")), /*#__PURE__*/React.createElement("g", {
    id: "Group_55",
    "data-name": "Group 55",
    transform: "translate(1300.388 171)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_49",
    "data-name": "Group 49",
    transform: "translate(104.495 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "love-svgrepo-com",
    d: "M51.54,1.971c17.386-.258,36.5,6.344,53.2,20.055,16.7-13.71,35.815-20.314,53.2-20.055,19.135.287,36.649,9.011,45.127,26.187,8.411,17.04,6.917,40.345-7.218,67.876-14.155,27.572-41.4,60.32-86.425,97.426a7.218,7.218,0,0,1-9.371,0c-45.029-37.105-72.27-69.853-86.425-97.425C-.5,68.5-2,45.2,6.413,28.158,14.891,10.982,32.4,2.257,51.54,1.971Z",
    transform: "translate(-1.249 -1.964)",
    fill: "#1c6834",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "love-svgrepo-com-2",
    "data-name": "love-svgrepo-com",
    d: "M51.54,195.18c17.386.258,36.5-6.344,53.2-20.055,16.7,13.711,35.815,20.314,53.2,20.055,19.135-.287,36.649-9.011,45.127-26.187,8.411-17.04,6.917-40.345-7.218-67.876C181.7,73.545,154.456,40.8,109.427,3.691a7.218,7.218,0,0,0-9.371,0C55.026,40.8,27.786,73.545,13.631,101.117-.5,128.649-2,151.955,6.413,168.993,14.891,186.164,32.4,194.9,51.54,195.18Z",
    transform: "translate(-1.249 221.274)",
    fill: "#1c6834",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_50",
    "data-name": "Group 50",
    transform: "translate(416.463 104.74) rotate(90)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "love-svgrepo-com-3",
    "data-name": "love-svgrepo-com",
    d: "M50.29.007c17.386-.258,36.5,6.344,53.2,20.055,16.7-13.711,35.815-20.314,53.2-20.055,19.13.28,36.649,9.011,45.127,26.187,8.411,17.04,6.917,40.345-7.218,67.876-14.155,27.572-41.4,60.32-86.425,97.426a7.218,7.218,0,0,1-9.371,0c-45.031-37.105-72.27-69.854-86.425-97.426C-1.754,66.539-3.248,43.232,5.166,26.194,13.634,9.018,31.153.287,50.29.007Z",
    transform: "translate(0 0)",
    fill: "#140f47",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "love-svgrepo-com-4",
    "data-name": "love-svgrepo-com",
    d: "M50.29,193.221c17.386.258,36.5-6.344,53.2-20.055,16.7,13.711,35.815,20.314,53.2,20.055,19.135-.287,36.649-9.011,45.127-26.187,8.411-17.04,6.917-40.345-7.218-67.876-14.155-27.573-41.4-60.321-86.425-97.43a7.218,7.218,0,0,0-9.371,0C53.775,38.837,26.536,71.584,12.381,99.156c-14.135,27.532-15.629,50.837-7.215,67.878C13.634,184.21,31.153,192.935,50.29,193.221Z",
    transform: "translate(0 223.234)",
    fill: "#140f47",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_54",
    "data-name": "Group 54",
    transform: "translate(124.916 50.512)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_42",
    "data-name": "Path 42",
    d: "M335.914,346.266c.522-.05,2.162-.25,3.8-.359a86.435,86.435,0,0,1,10.356-.537c4.762.26,9.492,1.1,14.247,1.592,5.085.522,10.178,1.059,15.282,1.318,2.515.126,16.649,0,16.649,0s5.214.088,7.692.049c21.344-.333,40.523-6.678,57.239-20.223a101.021,101.021,0,0,0,17.08-17.163,54.32,54.32,0,0,1,14.107-13.094,10.756,10.756,0,0,1,9.8-1.537,18.246,18.246,0,0,0,13.088-.248,5.533,5.533,0,0,1,4.319.03c2.311.894,4.612,1.866,6.991,2.523,3.643,1.016,7.32,1.941,11.043,2.621a12.094,12.094,0,0,0,4.88-.317,2.319,2.319,0,0,0,1.269-3.9,16.168,16.168,0,0,0-4.2-3.361c-3.769-2.055-7.643-3.93-11.518-5.783a13.7,13.7,0,0,1-7.169-6.469,16.382,16.382,0,0,0-7.373-7.136c-11.187-6.018-22.2-4.606-31.558,3.936-2.683,2.447-5.43,4.833-8.247,7.123a39.554,39.554,0,0,1-13.911,7.419,22.085,22.085,0,0,1-3.875.718,4.04,4.04,0,0,1-4.349-2.519c-6.008-11.612-11.685-23.359-15.339-35.97-1.1-3.8-1.981-7.68-3.254-11.425a28.261,28.261,0,0,0-3.4-7.085c-2.454-3.512-5.3-6.746-8.023-10.071-2.929-3.578-5.966-7.067-8.843-10.687q-8.325-10.478-16.506-21.063c-10.076-13.087-20.368-26.016-29.3-39.943-3.748-5.842-7.431-11.725-11.227-17.536a34.444,34.444,0,0,0-4.226-5.468c-1.737-1.754-3.847-1.085-4.6,1.247a14.61,14.61,0,0,0,.523,8.764,86.432,86.432,0,0,0,8.468,19.506c1.167,2,2.238,4.05,3.313,6.1.122.233,0,.6-.016.9-.287-.023-.68.072-.847-.08-1.455-1.345-2.809-2.806-4.315-4.091-2.637-2.248-5.318-4.449-8.065-6.556-.923-.708-2.253-1.168-3.1.016a3.72,3.72,0,0,0-.5,2.69,23.8,23.8,0,0,0,4.518,8.745q4.564,6.18,9.11,12.372a2.951,2.951,0,0,1,.278.91c-.438.046-.976.287-1.3.111-2.773-1.474-5.484-3.063-8.262-4.527a24.2,24.2,0,0,0-4.1-1.732,2.228,2.228,0,0,0-3.031,2.639,9.026,9.026,0,0,0,1.4,3.631,85.047,85.047,0,0,0,5.454,7.04c3.238,3.749,6.611,7.383,9.912,11.078a3.293,3.293,0,0,1,.4.88c-.439.03-.953.224-1.3.062-2.1-.966-4.126-2.114-6.261-3a13.411,13.411,0,0,0-4.273-1.072c-3.588-.2-5.065,1.918-3.31,4.965a54.457,54.457,0,0,0,5.5,7.607,238.086,238.086,0,0,0,24.04,24.3c.985.883,1.929,1.814,2.83,2.78a4.982,4.982,0,0,1,.636,1.262c-.451.063-.97.3-1.342.162-1.7-.647-3.318-1.5-5.034-2.094a71.114,71.114,0,0,0-7.571-2.269,9.139,9.139,0,0,0-3.93.143c-2.919.675-3.732,3.32-1.646,5.641a37.9,37.9,0,0,0,5.124,4.65c2.617,2.009,5.39,3.825,8.071,5.757a1.016,1.016,0,0,1,.3.861.922.922,0,0,1-.659.537,32.962,32.962,0,0,0-3.921.441,2.657,2.657,0,0,0-1.481,4.579,28.112,28.112,0,0,0,4.151,3.484c1.318.993,2.763,1.816,4.1,2.79,1.045.764,2.829,1.641,2.832,2.473.007,1.737-2.094.741-3.126,1.378a28.714,28.714,0,0,0-2.99,1.722,4.656,4.656,0,0,0-.825,7,64.032,64.032,0,0,0,5.715,5.474c.972.888,2.077,1.632,3.063,2.51A3.063,3.063,0,0,1,376.525,287a5.718,5.718,0,0,0,.687,4.713c1.665,3.38,2.789,7.023,5.143,10.069a6.075,6.075,0,0,1,.906,2.286,1.579,1.579,0,0,1-.94,2.029,21.766,21.766,0,0,1-3.311,1,48.082,48.082,0,0,0-13.515,4.716,363.242,363.242,0,0,1-35.416,16.7c-1.836.731-3.565,1.435-4.479,3.574-.431,1-1.958,1.642-3.11,2.193-1.936.923-4,1.586-5.949,2.476a9.969,9.969,0,0,0-2.427,1.662,1.668,1.668,0,0,0,.337,2.559c2.253,1.465,4.736,1.188,7.214.936,2.3-.232,4.574-.586,6.872-.739,1.353-.09,1.487.627,1.173,1.916-.63,2.576-.25,3.014,2.088,3.158C332.8,346.318,333.792,346.266,335.914,346.266Z",
    transform: "translate(-313.661 -130.707)",
    fill: "#f5f5f5"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_138",
    "data-name": "Group 138",
    transform: "translate(1033.849 769.736)"
  }, /*#__PURE__*/React.createElement("text", {
    id: "GROUP",
    transform: "translate(229.848 82.25)",
    fill: "#140f47",
    fontSize: 100,
    fontFamily: "CenturyGothic-Bold, Century Gothic",
    fontWeight: 700,
    letterSpacing: "0.2em"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "GROUP")), /*#__PURE__*/React.createElement("line", {
    id: "Line_5",
    "data-name": "Line 5",
    x2: 150,
    transform: "translate(736.348 50.733)",
    fill: "none",
    stroke: "#140f47",
    strokeLinecap: "round",
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_6",
    "data-name": "Line 6",
    x2: 150,
    transform: "translate(0.348 50.733)",
    fill: "none",
    stroke: "#140f47",
    strokeLinecap: "round",
    strokeWidth: 5
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogogroup);
export default __webpack_public_path__ + "static/media/logogroup.dc96304ef92c86a290098e3edd825f9d.svg";
export { ForwardRef as ReactComponent };